// import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'

const aiSettingResource = '/admin/settings/ai'

export default {
  getAiSetting() {
    return OperationsRepository.get(`${aiSettingResource}`)
  },
  updateAiSetting(payload) {
    return OperationsRepository.put(`${aiSettingResource}`, payload)
  },
  getClaudeReporting() {
    return OperationsRepository.get('/admin/settings/claude-reporting')
  },
  updateClaudeReporting(payload) {
    return OperationsRepository.put('/admin/settings/claude-reporting', payload)
  },
}
